export const calculateMedian = (arr: number[]): number => {
  try {
    const mid = Math.floor(arr.length / 2);
    const nums = [...arr?.map((item) => Number(item))].sort((a, b) => a - b);
    return arr.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
  } catch {
    return 0;
  }
};
